import React from "react";

const LoaderDialog = ({ visible }) => {
    if (!visible) return null; // No mostrar si no está activo
  
    return (
      <div className="dialog-overlay">
        <div className="dialog-content">
          <img
            src="./logo_makrosoft.png"
            alt="Cargando..."
            className="loader"
          />
        </div>
      </div>
    );
  };

  export default LoaderDialog